import type React from 'react';

import { ScrollRestoration } from 'react-router';

import type { BreadcrumbLink } from '@helsenorge/core-framework/breadcrumb';
import PageRoot from '@helsenorge/core-framework/pageroot';
import { getSidetittelId } from '@helsenorge/framework-utils/hn-page';

import { useAppSelector } from '../store/hooks';

interface Props {
  breadcrumbLink?: BreadcrumbLink;
  children: React.ReactNode;
}

const PageContainer: React.FunctionComponent<Props> = ({ children }: Props) => {
  const breadcrumb = useAppSelector(state => state.breadcrumb);

  return (
    <PageRoot hasFullwidth hasPageHeader={false} breadcrumbLink={breadcrumb} mainAriaLabelledby={getSidetittelId()}>
      <ScrollRestoration />
      {children}
    </PageRoot>
  );
};
export default PageContainer;
